import $ from 'jquery';
import _ from "underscore";
import run from '../../utilities/run';
import {isPresent} from "../../utilities/general";
import {setElementsFromScope} from "../../utilities/selectorHelpers";
import collectDataAttributesFor from "../../utilities/collectDataAttributesFor";
import {bindCheckboxRowItems, addSimpleCheckboxRows} from "../../utilities/additionalFilterLogic";
import pagination from "../../components/pagination/pagination";
import {applySortingRelatedIconsAndSetHiddenFields} from "../../utilities/filtersLegacy";
import LookupFilterElements from "../common/lookupFilterElements";
import {applySessionCachingLogic} from "../common/lookupSessionCaching";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT} from "../../constants";

run("#lookup-work-order-outer", ()=>{
  const el = $("#lookup-work-order-outer");
  workOrderLookup(el);
});

function workOrderLookup(el) {
  const els = {};
  const noop = (()=>{});
  const namespace = el.data("namespace");
  const workOrderFilterTypes = el.data("work-order-types");
  const workOrderFilterStatuses = el.data("work-order-statuses");
  const processingLabel = "Processing...";
  const errorMessageLabel = el.find("#process-error-message");
  window.migrateLookupFrontend = true;

  const filterElements = new LookupFilterElements(namespace);

  const elementsMap = filterElements.getElementsMap();
  const docElementsMap = filterElements.getDocElementsMap();

  _.extend(elementsMap, {
    emptyDiv: `#${namespace}lookup-work-order-table .dataTables_empty`,
    table: "#lookup-work-order-table"
  });

  _.extend(docElementsMap, {
    cancelWorkOrderModal: `#cancel-work-order-modal`,
    cancelWorkOrder: ".cancel-work-order",
    reasonForCancellation: "#cancelWOReason"
  });

  const defaultLookupDataTableOptions = {
    "searching": false,
    "paging": false,
    "ordering": false,
    "info": false
  };

  setElements();
  onLoad();

  const paginator = pagination(els.lookupOuter, {
    tableData: els.workOrders,
    lang: els.lang
  });

  function setElements() {
    setElementsFromScope(els, elementsMap, el);
    setElementsFromScope(els, docElementsMap, $(document));
    els.lookupOuter = el;
    els.filterUrl = el.data("filter-work-orders-url");
    els.detailUrl = el.data("work-order-detail-page-url");
    els.workOrders = els.table.data("work-orders");
    els.namespace = namespace;
    els.generalErrorMessage = el.data("general-error-message");
    els.createUpdateUrl = el.data("work-order-create-update-url");
    els.calcelUrl = el.data("work-order-cancel-url");
    els.shouldCheckCache = el.data("should-check-cache");
    els.savedFilterCriteria = el.data("saved-filter-criteria");
    els.extraDetailForCache = el.data("extra-detail-for-cache");
    els.searchCriteriaHiddenInput = el.data("hidden-input-search-criteria");
    els.additionalFilterkeyArr = ['status','type'];
  }

  function onLoad() {
    /* strip garbage attrs from additional-filter btn
       so we can handle the js concerns from the js*/
    els.additionalFilterOuter.removeAttr("data-toggle");
    //els.dateRangeFilter.removeAttr("data-toggle");

    els.sortFieldHiddenInput.val("worStatus");
    els.sortTypeHiddenInput.val("asc");
    els.itemsPerPageSelect.val(els.workOrders.page.size);

    els.additionalFilterOuter.show();
    els.dateRangeFilter.show();

    els.lang = collectDataAttributesFor(els.lookupOuter.get(0), {prefix: "lang", camelize: false});

    els.showAdditionalFilterInput.val(els.lang['work-order-additional-filter-text']);
    els.showDateRangeFilterInput.val(els.lang['lookup-filter-date-range-last7days']);
    els.dateRangeModalTitle.text(els.lang['lookup-filter-order-date-range-header']);

    const filterFields = [
      {
        value: "id",
        text: els.lang['work-order-table-filter-id']
      },
      {
        value: "subject",
        text: els.lang['work-order-table-filter-subject']
      },
      {
        value: "sku",
        text: els.lang['work-order-table-filter-product-sku']
      }
    ];

    if(els.workOrders.isCsrOrSysAdmin) {
      const retailerFilter = {
        value: "retailerName",
        text: els.lang['work-order-table-filter-retailer']
      };
      filterFields.push(retailerFilter);
    }

    _.each(filterFields, function(filterObj){
      const option = $('<option />');
      option.attr('value', filterObj.value).text(filterObj.text);
      /*
        The below if condition needs to be moved to 
        lookupSessionCaching.js.
      */
      if(els.shouldCheckCache === true) {
        window.setCacheFilterFields(option, els.savedFilterCriteria, filterObj.value, filterObj.text);
      }
      els.filterFieldsSelect.append(option);
    }); 

    let types = [];
    _.each(workOrderFilterTypes, function(typeObj){
      let type = {value : typeObj.cdmValue};
      types.push(type);
    });

    addSimpleCheckboxRows(els.modalFilterType, types);

    let statuses = [];
    _.each(workOrderFilterStatuses, function(statusObj){
      let status = {value : statusObj.cdmValue};
      statuses.push(status);
    });

    addSimpleCheckboxRows(els.modalFilterStatus, statuses);

    bindCheckboxRowItems({namespace: namespace});

    /**
      The below code is for to handle the session caching 
      for lookup page.
    */
    if(els.shouldCheckCache === true) {
      applySessionCachingLogic(els);
      setAdditionalFilterText();
    }

  }

  els.additionalFilterOuter.on("click", showAdditionalFiltersModal);  
  els.applyAddtionalFiltersModalBtn.on("click", handleApplyFiltersModalBtn);
  els.tableHeaderItems.on("click", onTableHeaderItemClick);

  function showAdditionalFiltersModal() {
    els.additionalFilterModal.modal("show");
  }

  function handleApplyFiltersModalBtn(e){
    e.preventDefault();
    /* Status */
    const statusValues = collectStatusValues();
    const typeValues = collectTypeValues();

    // DIRECT PORT :( No time to refactor
    window.addToCriteria('status', statusValues, 'equal');
    window.addToCriteria('type', typeValues, 'equal');

    els.additionalFilterModal.modal('hide');

    postLookupSearchHelper();

    setAdditionalFilterText(statusValues, typeValues);
  }

  function setAdditionalFilterText(statuses, types) {
    const statusValues = statuses || collectStatusValues();
    const typeValues = types || collectTypeValues();

    if (statusValues.length > 0 || typeValues.length > 0) {
      let totalAppliedFilters = 0;
      totalAppliedFilters = (isPresent(statusValues)?statusValues.length:0) + (isPresent(typeValues)?typeValues.length:0);
      els.showAdditionalFilterInput.val(totalAppliedFilters + ' ' + els.lang['lookup-filter-additional-filter-filters-applied']);
      els.clearFilters.show();
    } else {
      els.showAdditionalFilterInput.val(els.lang['work-order-additional-filter-text']);
      els.clearFilters.hide();
    }
  }

  function onTableHeaderItemClick() {
    const headerElement = $(this);
    applySortingRelatedIconsAndSetHiddenFields({
      headerElement, 
      elements: els, 
      sortField: headerElement.data('sort-field'), 
      callback: postLookupSearchHelper
    });
  }

  function postLookupSearchHelper({pageNumber=0}={}) {
    postLookupSearch({pageNumber: pageNumber, elements: els, success: receivePostLookupSearch});
  }


  function collectStatusValues() {
    return _($(elementsMap.filterStatusCheckboxes).filter(":checked").toArray()).map((el)=>{
      return $(el).val();
    });
  }

  function collectTypeValues() {
    return _($(elementsMap.filterTypeCheckboxes).filter(":checked").toArray()).map((el)=>{
      return $(el).val();
    });
  }

  let searchRequest;

  function postLookupSearch(options={}) {
    const {elements, pageNumber, size, orderBy, orderByType, url, success=noop, error=noop} = options;
    // Show loading overlay
    if(searchRequest){
      // console.log("aborting");
      searchRequest.abort();
    }

    searchRequest = $.ajax({
      url: url || els.filterUrl,
      type: 'POST',
      data: getCurrentPageDataForSearch(options),
      dataType: 'JSON',
      // DONT DO THIS
      // async: false,
      success: function(data) {
        // hide loading overlay
        searchRequest = null;
        success(data);
      },
      error: error
    });
  }

  function receivePostLookupSearch(newData){
    workOrdersDataTable.fnClearTable();
    els.workOrders = newData;
    if (els.workOrders.content.length > 0) {
      workOrdersDataTable.fnAddData(els.workOrders.content);
    } else {
     els.emptyDiv.text(els.lang['lookup-filter-no-results-found']);
    }
    paginator.setTableData(els.workOrders);
    window.pushFilterSessionCacheState(els.workOrders.page.size, els.workOrders.page.number);
  }

  function getCurrentPageDataForSearch({elements=els, pageNumber, size, orderBy, orderByType}){
    const dataStr = elements.form.serialize();
    const additionalDataStr = $.param({
      [`${namespace}page`]: (isPresent(pageNumber) ? pageNumber : 0),
      [`${namespace}size`]: (isPresent(size) ? size : elements.itemsPerPageSelect.val()),
      [`${namespace}orderBy`]: (isPresent(orderBy) ? orderBy : elements.sortFieldHiddenInput.val()),
      [`${namespace}orderByType`]: orderByType || elements.sortTypeHiddenInput.val()
    });

    return dataStr + "&" + additionalDataStr;
  }

  els.clearFilters.click(function(e) {
    // DIRECT PORT :( No time
    e.stopPropagation();

    els.modalFilterStatus.find(':checkbox').each(function() {
      $(this).prop('checked', false);
      $(this).parent().removeClass("additional-filter-selected");
    });

    els.modalFilterType.find(':checkbox').each(function() {
      $(this).prop('checked', false);
      $(this).parent().removeClass("additional-filter-selected");
    });

    /* remove criteria */
    window.addToCriteria('status', []);
    window.addToCriteria('type', []);

    els.showAdditionalFilterInput.val(els.lang['work-order-additional-filter-text']);
    $(this).hide();
    postLookupSearchHelper();
  });

  els.modalFilterCancel.click(function() {
    // DIRECT PORT :( No time
    els.modalFilterStatus.each(function() {
      window.applyAdditionalFilterCancel('status', $(this));
    });

    els.modalFilterType.each(function() {
      window.applyAdditionalFilterCancel('type', $(this));
    });
  });

  // This event notably comes from the backend js file,
  // this is a work-around for now to allow the abundance of
  // triggerSearch calls to be ported to the front
  els.lookupOuter.on('exec-search', handleExecSearchEvent);

  function handleExecSearchEvent(e, pageNumber){
    postLookupSearchHelper({pageNumber});
  }

  const workOrdersDataTable = els.table.dataTable({
    ...defaultLookupDataTableOptions,
    data: els.workOrders.content,
    columns: [
      {
        data: "worId",
        "class": "anchor-text",
        render: renderWorkOrderDetailLink
      }, 
      {
        data: "worSubject"
      }, 
      {
        data: "retailer.rtlName",
        "visible": els.workOrders.isCsrOrSysAdmin
      },
      {
        data: "worType"
      }, 
      {
        data: "worReqCompletionDate",
        "visible": els.workOrders.isCsrOrSysAdmin
      },
      {
        data: "worEstiCompletionDate",
        "visible": els.workOrders.isRetailer
      }, 
      {
        data: "statusPill"
      }, 
      {
        data: "worActionIcons"
      }
    ]
  });

  function renderWorkOrderDetailLink(data, type, row) {
    return `<a href=${els.detailUrl}&worId=${data}&retailerId=${row.retailer.rtlId}> ${data} </a>`;
  }

  els.table.on("click", "tbody td .cancel-work-order-icon", function() {
    let row = workOrdersDataTable.api().row( $(this).closest('tr'));
    els.cancelWorkOrderModal.appendTo("body").data('row', row).modal("show");
  });

  els.table.on("click", "tbody td .edit-wo-icon", function() {
    let row = workOrdersDataTable.api().row( $(this).closest('tr'));
    location.href = `${els.createUpdateUrl}&worId=${row.data().worId}`;
  });  

  els.cancelWorkOrder.on("click", function() {
    if(els.reasonForCancellation.val().length == 0){ //validation
      return false;
    }

    const submitModalFlow = new SubmitModalFlow();
    submitModalFlow.init();
    els.cancelWorkOrderModal.modal("hide");
    submitModalFlow.showLoadingModal();
    
    let $this = $(this);
    $this.fadeTo(500, 0.3);
    let label = $this.html();
    $this.html(processingLabel); 

    let row =  els.cancelWorkOrderModal.data('row');
    $.ajax({
      url: els.calcelUrl,
      type: "POST",
      data: {
        worId: row.data().worId,
        comment: els.reasonForCancellation.val()
      },
      dataType: "JSON",
      success: function(data) {
        if(data.status === "Success") {
          els.reasonForCancellation.val("");
          $this.fadeTo(500, 1);
          $this.html(label);
          let d = row.data();
          d.worId=row.data().worId;
          d.worSubject=row.data().worSubject;
          d.worType=row.data().worType;
          d.worEstiCompletionDate=row.data().worEstiCompletionDate;
          d.worActionIcons=`<div style='float:left'> <i class='fa fa-ban fa-lg' style='color:lightgrey; cursor:not-allowed;'></i>
                              &nbsp;&nbsp;&nbsp;<i class='fa fa-pencil fa-lg' style='color:lightgrey; cursor:not-allowed;'> </i> </div>`;
          d.statusPill=`<div class='q-pill q-pill-light-grey q-pill-table'>Canceled</div>`;
          row.data(d).draw();
          submitModalFlow.showSuccessModal();
          setTimeout(function() {
            submitModalFlow.hideAllModals();
          }, SUCCESS_MODAL_TIMEOUT);
        }else{
          submitModalFlow.showFailureModal();
        }
      },
      error: function(){
        submitModalFlow.hideAllModals();
      }
    });
  });
}


// WEBPACK FOOTER //
// ./src/pages/workorder/lookup.js